import {
  FETCH_WORKFLOW,
  FETCH_PRODUCTS,
  UPDATE_CURRENT_GUID,
  UPDATE_SEEN_GUIDS,
  UPDATE_CURRENT_PROMPT,
  UPDATE_DEFAULT_SUPPORT_SKILL,
  UPDATE_SFDC_TYPE,
  UPDATE_SFDC_TOPIC,
  UPDATE_PREMIUM_SUPPORT_SKILL,
  UPDATE_PREMIUM_SFDC_TYPE,
  UPDATE_PREMIUM_SFDC_TOPIC,
  UPDATE_RESOLVED_SUPP_SKILL,
  UPDATE_SHOW_CONTACT_FOOTER,
  UPDATE_DEFAULT_ESCAPE_ACTION_GUID,
  UPDATE_SHOW_CONTACT_DETAILS_IN_ACTION,
  UPDATE_HIDE_TOPIC_NOT_LISTED,
  UPDATE_CURRENT_TOP_LEVEL_BRANCH,
  UPDATE_HIDE_CONTACT,
  UPDATE_SHOW_RESELLER_CONTACT,
  UPDATE_USER_CONTEXT,
  UPDATE_LINK_TO_ADN_SUPPORT_PAGE,
  RESET_DISAMBIGUATION_STATES,
} from '../actions/types';

const initialState = {
  currentGuid: 'start',
  seenGuids: [],
  workflowData: {},
  currentPrompt: {},
  defaultSupportSkill: '',
  resolvedSkill: '',
  productsReleases: [],
  showContactFooter: false,
  defaultEscapeActionGuid: '',
  showContactDetailsInAction: false,
  hideTopicNotListed: false,
  hideContactModalities: false,
  showResellerContactModality: false,
  sfdcType: '',
  sfdcTopic: '',
  resolvedSfdcType: '',
  resolvedSfdcTopic: '',
  currentTopLevelBranch: '',
  premiumSupportSkill: '',
  premiumSfdcType: '',
  premiumSfdcTopic: '',
  userContext: '',
  linkToADNSupportPage: false,
};

const defaultTypes = {
  CS: 'Other',
  IA: 'Other',
  NX: 'Other',
  IL: 'Installation, Activation & Registration',
  PRE: 'eStore - Pre-Sales',
  RA: 'Installation, Activation & Registration',
  TS: 'Troubleshooting Products & Services',
};

const defaultTopics = {
  CS: 'General',
  IA: 'General',
  NX: 'General',
  IL: 'Installation Troubleshooting',
  PRE: 'Subscription Help',
  RA: 'General Registration Help',
  TS: 'Product Troubleshooting',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WORKFLOW:
      return {...state, workflowData: action.payload};
    case FETCH_PRODUCTS:
      return {...state, productsReleases: action.payload};
    case UPDATE_CURRENT_GUID:
      return {...state, currentGuid: action.payload};
    case UPDATE_SEEN_GUIDS:
      return {...state, seenGuids: action.payload};
    case UPDATE_CURRENT_PROMPT:
      return {...state, currentPrompt: action.payload};
    case UPDATE_DEFAULT_SUPPORT_SKILL:
      return {...state, defaultSupportSkill: action.payload};
    case UPDATE_SFDC_TYPE:
      return {...state, sfdcType: action.payload};
    case UPDATE_SFDC_TOPIC:
      return {...state, sfdcTopic: action.payload};
    case UPDATE_PREMIUM_SUPPORT_SKILL:
      return {...state, premiumSupportSkill: action.payload};
    case UPDATE_PREMIUM_SFDC_TYPE:
      return {...state, premiumSfdcType: action.payload};
    case UPDATE_PREMIUM_SFDC_TOPIC:
      return {...state, premiumSfdcTopic: action.payload};
    case UPDATE_RESOLVED_SUPP_SKILL:
      if (action.payload === '') {
        return {
          ...state,
          resolvedSfdcTopic: '',
          resolvedSfdcType: '',
          resolvedSkill: action.payload,
        };
      } else {
        const {defaultSupportSkill} = state;
        if (typeof action.payload === 'object') {
          if (
            action.payload.skill &&
            action.payload.type &&
            action.payload.topic
          ) {
            return {
              ...state,
              resolvedSfdcTopic: action.payload.topic,
              resolvedSfdcType: action.payload.type,
              resolvedSkill: action.payload.skill,
            };
          }
        }
        if (defaultSupportSkill !== action.payload && action.payload !== '') {
          return {
            ...state,
            resolvedSfdcTopic: defaultTopics[action.payload],
            resolvedSfdcType: defaultTypes[action.payload],
            resolvedSkill: action.payload,
          };
        } else {
          return {
            ...state,
            resolvedSfdcTopic: '',
            resolvedSfdcType: '',
            resolvedSkill: action.payload,
          };
        }
      }
    case UPDATE_SHOW_CONTACT_FOOTER:
      return {...state, showContactFooter: action.payload};
    case UPDATE_DEFAULT_ESCAPE_ACTION_GUID:
      return {...state, defaultEscapeActionGuid: action.payload};
    case UPDATE_SHOW_CONTACT_DETAILS_IN_ACTION:
      return {...state, showContactDetailsInAction: action.payload};
    case UPDATE_HIDE_TOPIC_NOT_LISTED:
      return {...state, hideTopicNotListed: action.payload};
    case UPDATE_HIDE_CONTACT:
      return {...state, hideContactModalities: action.payload};
    case UPDATE_SHOW_RESELLER_CONTACT:
      return {...state, showResellerContactModality: action.payload};
    case UPDATE_CURRENT_TOP_LEVEL_BRANCH:
      return {...state, currentTopLevelBranch: action.payload};
    case UPDATE_USER_CONTEXT:
      return {...state, userContext: action.payload};
    case UPDATE_LINK_TO_ADN_SUPPORT_PAGE:
      return {...state, linkToADNSupportPage: action.payload};
    case RESET_DISAMBIGUATION_STATES:
      return {
        ...state,
        linkToADNSupportPage: false,
        resolvedSkill: '',
        resolvedSfdcTopic: '',
        resolvedSfdcType: '',
        currentGuid: 'start',
        seenGuids: [],
      };
    default:
      return state;
  }
};
